import { Component, NgZone, OnInit } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';
import { ATTEMPS_CONFIG, ATTEMPS_CONFIG_FTD } from './attemps.component.config';
import { AccUrl, ftdUrl } from '@core/layouts/default/default.config';

@Component({
  selector: 'shell-attempts',
  templateUrl: './attempts.component.html',
  styleUrls: ['./attempts.component.scss'],
})
export class AttemptsComponent implements OnInit {
  config: ModalErrorConfig;
  modalError: any;

  constructor(
    private modalService: ModalService,
    public microFrontendRouter: MicroFrontendRouter,
    public messageBusService: MessageBusService,
    public ngZone: NgZone,
  ) {}

  closeModal(): void {
    switch (this.modalError?.project) {
      case PROJECTS.ACC:
        window.location.href = window.location.origin + AccUrl.preferentialPen;
        break;
      case PROJECTS.PLD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.FTD:
        window.location.href = window.location.origin + ftdUrl.firstPage;
        break;
    }
    this.modalService.close();
    window.location.reload();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBusService.getValue('shell', 'modal.error');
        switch (this.modalError?.project) {
          case PROJECTS.ACC:
            this.config = ATTEMPS_CONFIG;
            break;
          case PROJECTS.PLD:
            this.config = ATTEMPS_CONFIG;
            break;
          case PROJECTS.FTD:
            this.config = ATTEMPS_CONFIG_FTD;
            break;
        }
      });
    });
  }
}
